export default (theme) => ({
  lifestyleImgSection: {
    backgroundColor: theme.color.black_11,
    height: 400,
    width: '100%',
    position: 'relative',
  },
  lifestyleCam: {
    backgroundColor: theme.color.white,
    color: theme.color.black,
    width: 18,
    height: 18,
    position: 'absolute',
    top: '5%',
    right: '5%',
    opacity: 1,
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: theme.color.gray,
      opacity: 0.5,
    },
    '& > svg': {
      width: 15,
      height: 15,
    },
  },
  lifestyleImg: {
    maxWidth: '100%',
    maxHeight: '100%',
  },
  profileImgSection: {
    width: 80,
    height: 80,
    position: 'absolute',
    top: '90%',
    left: '5%',
    fontSize: 24,
    color: theme.palette.text.white,
    backgroundColor: theme.color.black_11,
    border: '2px solid white',
    zIndex: 1,
  },
  profileOverlayCam: {
    top: '101.2%',
    left: '5.6%',
    width: 75,
    height: 31.5,
    opacity: 0.5,
    position: 'absolute',
    backgroundColor: 'rgb(99 99 99)',
    zIndex: 2,
    borderBottomLeftRadius: 60,
    borderBottomRightRadius: 60,
    justifyContent: 'center',
    alignItems: 'center',
  },
  profileCam: {
    color: theme.color.white,
    width: 18,
    height: 18,
    opacity: 1,
    '&:hover': {
      cursor: 'pointer',
      backgroundColor: theme.color.gray,
      opacity: 0.5,
    },
  },
  saInitials: {
    position: 'relative',
    top: '-10%',
    left: '0%',
  },
  saInitialsEdit: {
    position: 'relative',
    top: '0%',
    left: '0%',
  },
});
